import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { isArrayCheck } from "../../../containers/generics/CheckArray";
import { FleetInitialValuesType } from "./fleet.type";
import { booleanSchema } from "./helper";
import { fromJS } from "immutable";

const initialState: FleetInitialValuesType = {
  fleets: [],
  selectFleets: [],
  errors: [],
  fleetsMap: [],
};

const newInitialState = fromJS(initialState);

const fleetSlice = createSlice({
  name: "fleet",
  initialState: newInitialState,
  reducers: {
    setFleets: (state, action) => {
      let fleetsMap: any = {},
        selectFleets: any = [];
      if (isArrayCheck(action.payload)) {
        action.payload.forEach((e: { regNumber: any }) => {
          fleetsMap[e.regNumber] = e;
          if (e.regNumber) {
            selectFleets.push({ label: e.regNumber, value: e.regNumber });
          }
        });
      }

      state = state
        .set("fleets", action.payload)
        .set("fleetsMap", fleetsMap)
        .set("selectFleets", selectFleets)
        .set("errors", { ...booleanSchema(true) });
      return state;
    },
  },
});

export const { setFleets } = fleetSlice.actions;

export default fleetSlice.reducer;

export const selectRight = (state: RootState) => state.fleet;
// export const selectIsLoading = (state: RootState) => state.user.isLoading;
// export const selectError = (state: RootState) => state.user.error;
